<app-members-list [selectedGroup]="selectedGroup" [authUser]="authUser" [hidden]="groupChatMessagesStore.showMembersForm"></app-members-list>
<app-members-add-form [selectedGroup]="selectedGroup" [authUser]="authUser" [hidden]="!groupChatMessagesStore.showMembersForm"></app-members-add-form>
